export const QUY_TRINH_THANH_TOAN_TOUR_MARKDOWN = `
# QUY TRÌNH THANH TOÁN, BÀN GIAO VÀ QUYẾT TOÁN TOUR

![Quy trình thanh toán bàn giao quyết toán tour](/images/quy-trinh-thanh-toan-ban-giao-quyet-toan-tour.png)

**(Cập nhập 22/07/2026)**

- **Người soạn**: Nguyễn Thị Thu Xuân (Chức vụ: Kế toán)
- **Người duyệt**: Nguyễn Nhất Vũ (Chức vụ: Giám Đốc Điều Hành)
- **Ngày duyệt**: 22/07/2026
- **Ngày áp dụng**: 23/07/2026.
- **Ngày hết hạn**: Cho đến khi có thông báo mới

### Phạm vi áp dụng
Tại công ty FIT TOUR. 

### Đối tượng áp dụng
* Bộ phận Điều Hành
* Bộ phận Kế Toán
* Bộ Phận Sales – Trip Planners.
* Các bộ phận Kinh Doanh khác liên quan đến Tours khởi hành
* Bộ phận HDV (Kể cả HDV Freelance)

## 1. QUY TRÌNH THANH TOÁN CHI PHÍ TOUR

### 1.1 Các bước thực hiện
* **Bước 1**: Điều hành lập đề xuất thanh toán khi có chi phí phát sinh.
* **Bước 2**: Kinh doanh cung cấp bản dự toán tour đi kèm để đối chiếu.
* **Bước 3**: Kinh doanh viết Cam kết thanh toán nếu tour chưa nhận cọc.
* **Bước 4**: Trưởng team kiểm tra toàn bộ và ký duyệt đồng ý thông qua.
* **Bước 5**: Kế toán kiểm tra tính hợp lệ và thực hiện chi tiền.

### 1.2 Bộ hồ sơ bắt buộc
* **Mail đề xuất thanh toán**: Ghi rõ tiêu đề tour, nội dung, số tiền, hạn thanh toán.
* **Bản dự toán tour**: Thể hiện rõ hạn mức chi phí được duyệt.
* **Mail cam kết của Kinh doanh**: Chỉ bắt buộc khi tour chưa nhận cọc.
* **Mail phê duyệt**: Mail đồng ý bắt buộc của Trưởng team.

### 1.3 Nội dung bắt buộc trong Mail cam kết của Kinh doanh
* Lý do khách hàng chưa đặt cọc.
* Thời gian chính xác khách sẽ xuống tiền cọc hoặc thanh toán.
* Trách nhiệm thu hồi công nợ của nhân viên kinh doanh.
* Phương án xử lý nếu khách hủy tour đột xuất.

### 1.4 Quy định thời gian
**Đối với các thanh toán nội địa:**
* Thời gian đề xuất: Trước ngày cần thanh toán tối thiểu 03 ngày làm việc.
* Thời gian duyệt: Trưởng team duyệt trong vòng 04 giờ làm việc.
* Thời gian chi tiền: Kế toán giải ngân vào khung giờ cố định 15:00 đến 17:00 mỗi ngày.

**Đối với các thanh toán land tour nước ngoài:**
* Thời gian đề xuất: Trước ngày cần thanh toán tối thiểu 07 ngày làm việc.
* Thời gian duyệt: Trưởng team duyệt trong vòng 04 giờ làm việc.
* Thời gian chi tiền: Kế toán giải ngân vào khung giờ cố định 14h mỗi ngày.

### 1.5 Quy định cho Kế toán
* **Tour đã có cọc**: Kế toán đi tiền theo dự toán và đề xuất.
* **Tour chưa có cọc**: Kế toán tuyệt đối từ chối chi nếu thiếu Cam kết thu tiền của Kinh doanh và Cam kết chịu trách nhiệm của Trưởng team.

## 2. THỦ TỤC BÀN GIAO TOUR

### 2.1 Đối với Nhân Viên Kinh Doanh
1. Kiểm tra Danh Sách nhập Namelist – Roomlist.
2. Kiểm tra tính chất khách và các cập nhật khác: Khách ăn chay, Phòng lưu trú, xe cộ, giờ giấc.
3. Phụ trách theo dõi công nợ thu chi trước khi bàn giao:
   * Tour Khách lẻ: Thanh toán 100% trước khởi hành.
   * Tour Khách Đoàn, nhóm riêng: Theo HĐ đã ký trước đó (100% tour khách đoàn/nhóm phải có HĐ).
4. Nhân viên Admin phối hợp với điều hành lên dự toán trước chuyến đi, và gửi cho kế toán trước khi bàn giao và khởi hành bằng Email.
5. Trước khởi hành tối thiểu 7 ngày hoặc sau khi có Visa, yêu cầu NVKD thu đủ số tiền thanh toán đợt 2 để đảm bảo dòng tiền cho công ty.
6. Nếu khách hàng (khách lẻ) chưa thanh toán, nhân viên phải giải trình cho BGĐ biết lý do. Tuỳ trường hợp cụ thể mà BGD sẽ quyết định có quy định can thiệp, nặng nhất là KHÔNG CHO KHỞI HÀNH.

### 2.2 Bộ Phận Visa
1. Phối hợp với Bộ Phận Điều hành để biết các Dealine và Timeline cụ thể.
2. Bàn giao đầy đủ và đúng hẹn lịch Visa để không ảnh hưởng tới tiến trình xuất vé máy bay.
3. Luôn luôn kiểm tra sự hợp pháp của Visa. Ngăn chặn và báo cáo các trường hợp mà phòng Visa cảm thấy nghi ngờ tính hợp pháp (Khách bỏ trốn, Visa không hợp lệ, hoặc các thay đổi về quy định mà không được cập nhật).
4. Luôn có Biên Bản Bàn Giao bằng Văn Bản, có chữ ký có nhân viên Visa và Điều Hành (In thành 2 bản, mỗi bên giữ 1 bản).

### 2.3 Đối với Nhân Viên Điều Hành và HDV
* Bàn giao đầy đủ các loại giấy tờ theo quy định của Tổng Cục Du Lịch và công ty TNHH Du lịch Quốc Tế FIT TOUR.
* Kiểm tra Danh sách Thu – Chi từ nhân viên Sales.
* Cụ thể như sau (luôn luôn kèm Check-list tour).
* Luôn luôn có chữ ký và kiểm tra của Trưởng Phòng Điều Hành.
* Điều hành luôn luôn là người tạo nhóm Chuyến đi, sau đó mời Sale để thêm các thành viên khác theo Cú Pháp sau:
  * Thời gian lập nhóm tối thiểu 7 ngày trước khởi hành.
  * TÊN CHUYẾN ĐI – CODE ĐOÀN – NGÀYKH – TÊN HDV.
  * Ví dụ: Tour Ladakh, Khởi hành 28/4, Có Code Đoàn là LADAKH63, HDV Nguyễn Văn A.
  * Cú pháp như sau: \`LADAKH64 - 28APR - TL VAN A\`

| STT | Danh mục | Diễn giải | Ghi chú |
|---|---|---|---|
| 1 | GPLH Quốc Tế | Bản sao | |
| 2 | CT Tour (Tiếng Việt) | Đóng mộc công ty | |
| 3 | Namelist + Roomlist | Đóng mộc công ty | |
| 4 | Bảo hiểm DL | Bản Scan | |
| 5 | Vé Máy Bay | | |
| 6 | HĐ HDV | | |
| 7 | Các Thủ tục liên quan khác | Cờ cty/ Áo đi tour<br>Nón công ty/đối tác<br>Tag hành lý – dây đeo<br>Banner<br>Sim<br>Phiếu đánh giá<br>Áo và cờ FIT TOUR<br>Và các thủ tục liên quan khác | Có Check list và chữ ký với HDV. |

### 2.4 Đối với Kế Toán
* Kiểm tra Dự Chi (Dự Toán Tour trước Khởi hành).
* Kiểm tra Thu – Chi đối với Nhân viên Kinh doanh.
* Báo cáo với BGD các trường hợp NVKD không thu đủ tiền đợt 2 hoặc có vấn đề về thanh toán.

### 2.5 Đối với HDV khi nhận bàn giao tour
Luôn có Checklist kiểm tra chéo với Điều hành Tour Trực Tiếp.
1. Kiểm tra Chương trình tiếng Việt Bàn Giao và Xác nhận tour với đối tác.
2. Kiểm tra Danh Sách Đoàn.
   * Danh sách chia xe (nếu có)
   * Danh sách chia phòng.
   * Vé máy bay - Visa Nhập Cảnh
   * Confirmed đối tác.
   * Các thủ tục liên quan khác nằm trong check-list.
3. Công tác Phí và thu nhập theo thoả thuận trước chuyến đi, sẽ được đưa vào HĐ được ký kết.
   * Lương Tour
   * Tiền Tip.
   * Thu nhập khác nếu có: Commision/ Shop…
4. Công tác liên lạc trước chuyến đi:   
   * HDV luôn được add vào nhóm bởi Điều Hành.
   * HDV phải liên hệ trước với khách bằng cả 2 cách: Thông báo bằng Zalo/Mess/WA/Viber và liên hệ bằng cách gọi trực tiếp.
5. Trên Chuyến đi:
   * Báo cáo mỗi ngày với HDV bằng cách chụp hình/quay clip bằng điện thoại (quay đứng) ngắn đoàn Report mỗi ngày.

| Dịch vụ | Quy cách | Yêu cầu |
|---|---|---|
| Máy bay | - Đoàn ở sân bay hoặc Phòng Chờ.<br>- Chụp nội thất trên máy bay<br>- Suất ăn nếu có. | Mỗi mục tối thiểu 2-4 hình khác nhau. |
| Xe Vận Chuyển | - Ngoại thất<br>- Nội thất<br>- Ghế ngồi | 4-6 tấm |
| Khách Sạn<br>(Quay Clip) | - Lễ tân (Chụp hình)<br>- Phòng (Quay Video)<br>- Bữa sáng (Chụp hình)<br>- Các dịch vụ khác | 10 – 20 tấm |
| Nhà Hàng | - Chụp hình tất cả các bữa ăn<br>- Đánh giá chất lượng bữa ăn | Mỗi nhà hàng 2-4 tấm. |
| Điểm Tham quan | - Chụp tập thể mỗi ngày, có Bandroll nếu quy định cho phép. | Tối thiểu 4 tấm/ ngày x số ngày tham quan. |
| Các dịch vụ khác | | |

### 2.6 CÁC CHẾ TÀI ÁP DỤNG VÀ GIẢI PHÁP
Tuỳ vào các sự cố phát sinh mà công ty sẽ giải quyết các trường hợp cụ thể, đồng thời đánh giá mức độ nghiêm trọng của sự cố mà đưa ra các phương án khắc phục và hướng xử lý theo các nguyên tắc sau:
* Giải quyết trước, Giải thích sau.
* Sự hài lòng của khách hàng.
* Nghĩa vụ của công ty và trách nhiệm quyền hạn của nhân viên là không thể tách rời.
* Tổng Chi phí phát sinh = 40% công ty + 60% (Chia đều các Bộ Phận liên quan).
* Cách thức truy thu: Trừ trực tiếp vào thu nhập tour đó.

| STT | Lỗi thường gặp | Nhân Viên KD | Điều Hành | Kế Toán | HDV | Visa | Cty |
|---|---|---|---|---|---|---|---|
| 1 | Vé MB sai tên | X | X | | | | |
| 2 | Visa sai thông tin | X | | | | X | |
| 3 | Khách bị từ chối xuất cảnh | X | X | | | | X |
| 4 | Danh Sách Chia Phòng | X | X | | | | |
| 5 | Phát sinh trên chuyến đi: Vé tham quan do chương trình không thống nhất, hoặc HDV hứa nhưng không bàn giao | X | X | | | | |
| 6 | Các sự cố Bất khả kháng | | | | | | X |

## 3. QUY TRÌNH QUYẾT TOÁN CHI PHÍ TOUR

### 3.1 Hướng dẫn viên (HDV)
* **Thời gian**: Trong vòng 48 giờ sau khi tour kết thúc.
* **Bàn giao vật dụng**: Trả lại cờ, thẻ tên, hộp y tế, máy bộ đàm.
* **Bàn giao tài chính**: Nộp lại tiền tạm ứng thừa (nếu có).
* **Bàn giao chứng từ**: Gửi hóa đơn, biên nhận chi phí phát sinh trên tour.

### 3.2 Đối với Điều hành
* **Thu thập dữ liệu**: Nhận chứng từ thực tế từ HDV.
* **Xử lý phát sinh**: Xác minh và tổng hợp các chi phí ngoài dự toán.
* **Tính toán chế độ**: Lập bảng kê công tác phí và tiền TIP cho HDV.
* **Hoàn thiện hồ sơ**: Đề xuất chi/thu phát sinh và lập bảng quyết toán tour.

### 3.3 Đối với Kinh doanh
* **Khách đoàn**: Gửi đối chiếu dịch vụ, ký biên bản thanh lý với khách hàng và gửi thông tin xuất hóa đơn cho bộ phận kế toán.
* **Khách lẻ tồn đọng**: Liên hệ thu hồi nốt phần tiền tour chưa thanh toán.
* **Thời hạn hoàn tất**: Thu hồi công nợ theo đúng điều khoản hợp đồng.

### 3.4 Đối với Kế toán - Trưởng Team hoàn tất (Chốt tour)
* **Kiểm tra đối chiếu**: Trưởng team xác nhận số liệu phát sinh giữa Dự toán ban đầu và Quyết toán thực tế.
* **Xử lý tài chính**: 
  * Đối với HDV: thu hồi tiền tạm ứng, Chi trả tiền công tác phí/phát sinh HDV vào ngày 15 hàng tháng.
  * Đối với công nợ đối tác: Thanh toán các dịch vụ theo quy trình thanh toán.

`;